/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */


import {FeatureDetailRes} from './product.contract';

export class LicenseAssignReq {
    licenseKey!: string;
    userId!: number;
}


export class UserLicensesRes {
    productId!: string;
    licenseId!: number;
}

export class LicenseOrderReq {
    productId!: string;
    amount: number = 1;
    bankAccountId: string | null = null;
    addressId: number | null = null;
    autoRenewEnabled: boolean = true;
    selectedFeaturesIds: number[] = [];
    demoSelected: boolean = false;

    selectedFeatures: FeatureDetailRes[] = [];
}